if (!customElements.get('blog-recommendations')) {
	class BlogRecommendations extends HTMLElement {
		constructor() {
			super();
            this.container = this.querySelector('[data-recc-carousel]') ?? '';
		}

		connectedCallback() {
            this.initCarousel();
		}

        initCarousel() {
            if (!this.container) return;
            
            const placeholder = this.container.parentElement.dataset?.recc;

            if (placeholder && placeholder === 'primary') {
                const elementToReplace = document.querySelector('#featuredProductsPrimaryPlaceholder');
                this.appendToElement(elementToReplace, this.container.parentElement);
            } else if (placeholder && placeholder === 'secondary') {
                const elementToReplace = document.querySelector('#featuredProductsSecondaryPlaceholder');
                this.appendToElement(elementToReplace, this.container.parentElement);
            }
            
            $(this.container).not('.slick-initialized').slick({
                    dots: false,
                    arrows: true,
                    prevArrow: `<div class="slick-prev"><svg class="prevArrow" role="presentation" viewBox="0 0 11 18">
                    <path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                </svg></div>`,
                    nextArrow: `<div class="slick-next"> <svg class="nextArrow" role="presentation" viewBox="0 0 11 18">
                    <path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                </svg></div>`,
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    autoplay: false,
                    mobileFirst: true, 
                    responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    }
                    ]
                }
            ); 
        }
        
        appendToElement(elementToReplace, elementToAppend) {
            if (elementToReplace && elementToReplace.innerHTML == "") {
                elementToReplace.append(elementToAppend);
            }
        }
	}
	customElements.define('blog-recommendations', BlogRecommendations);
}